import { render } from "./AppInputSearch.vue?vue&type=template&id=39838386&scoped=true"
import script from "./AppInputSearch.vue?vue&type=script&lang=js"
export * from "./AppInputSearch.vue?vue&type=script&lang=js"

import "./AppInputSearch.vue?vue&type=style&index=0&id=39838386&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39838386"]])

export default __exports__